import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_AUTHENTICATION, PATH_USERS, PATH_RESETPASSWORD } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import {
  setUserSession,
  setCurrentUser,
  isAuthTokenValid,
  getAuthToken,
  clearAllAuthentication
} from '@/lib/authentication'
import { buildSeoUrl } from '@/lib/url'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import { notifySuccess, notifyError } from '@/lib/notifications'

const authentication = {
  namespaced: true,
  state: {
    isAuthenticated: isAuthTokenValid()
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus
  },
  actions: {
    login ({ commit, dispatch }, credentials) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Authenticating, please wait...' })
      return api.doPost({ path: PATH_AUTHENTICATION, data: credentials })
        .then(result => result.data)
        .then((userSession) => {
          commit('updateStatus', { status: COMPLETE })
          hideProgressModal({ dispatch })

          if (!userSession) {
            throw Error('Unable to log in. Please, verify your credentials and try again.')
          }

          setUserSession(userSession)
          return userSession
        }).then((userSession) => {
          commit('updateStatus', { status: IN_PROGRESS })

          // return api.doGet({ path: PATH_USERS, parameters: { id: userSession.userId } })
          return api.doGet({ path: `${PATH_USERS}/${userSession.userId}` })
        }).then(result => result.data)
        .then((currentUser) => {
          commit('updateStatus', { status: COMPLETE })
          hideProgressModal({ dispatch })

          setCurrentUser(currentUser)
          // commit('setCurrentUser', currentUser)
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })

          notifyError(dispatch, error.message || 'Unable to log in. Network error.')
        })
    },
    logout () {
      const currentToken = getAuthToken()

      if (currentToken) {
        api.doDelete({ path: PATH_AUTHENTICATION, parameters: { sessionToken: currentToken } })
      }

      clearAllAuthentication()
    },
    resetPassword ({ commit, dispatch }, userEmailRequest) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Please wait...' })
      return api.doPost({ path: PATH_RESETPASSWORD, data: userEmailRequest })
        .then(result => result.data)
        .then(flagResult => {
          if (flagResult) {
            notifySuccess(dispatch, 'Password reset email was sent.')
          } else {
            notifyError(dispatch, 'Verify your account and try again')
          }
          commit('updateStatus', { status: COMPLETE })
          hideProgressModal({ dispatch })
          return flagResult
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })

          notifyError(dispatch, error.message || 'Unable to reset password. Network error.')
        })
    },
    validateResetPasswordToken ({ commit, dispatch }, token) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Please wait...' })
      return api.doGet({ path: buildSeoUrl(PATH_RESETPASSWORD, { token }) })
        .then(result => result.data)
        .then(flagResult => {
          if (!flagResult) {
            notifyError(dispatch, 'Password reset request is expired. Please, request another password reset and try again.')
          }
          commit('updateStatus', { status: COMPLETE })
          hideProgressModal({ dispatch })
          return flagResult
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })

          notifyError(dispatch, error.message || 'Unable to validate reset password. Network error.')
        })
    },
    changePasswordByToken ({ commit, dispatch }, changePasswordRequest) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Please wait...' })
      return api.doPut({ path: PATH_RESETPASSWORD, data: changePasswordRequest })
        .then(result => result.data)
        .then(() => {
          notifySuccess(dispatch, 'Password was changed successfully')
          commit('updateStatus', { status: COMPLETE })
          hideProgressModal({ dispatch })
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })

          notifyError(dispatch, error.message || 'Unable to change password. Network error.')
        })
    }
  }
}

export default authentication
